<template>
  <div
    :class="[
      _.container,
      noPager && _.noPager,
      theme.gridType === 1 && _.style2,
    ]"
    :style="{
      '--cols': theme.rowCount,
      '--padding': $transformPx(theme.innerMargin || 0),
    }"
  >
    <van-swipe :class="_.grids">
      <van-swipe-item
        v-for="(group, groupIndex) in groupData"
        :key="groupIndex"
        :class="_.grid"
      >
        <div
          v-for="(item, itemIndex) in group"
          :key="itemIndex"
          v-track="{
            name: '图标宫格-项目',
            id: `DianJiZiDingYiYeZiYuan`,
            resource: item,
            index: itemIndex,
            extra: item && getTrackExtra(item, itemIndex),
          }"
          :class="_.item"
          @click="$dmbcResourceClick(item)"
        >
          <template v-if="item">
            <img :src="item.icon" :class="_.icon" />
            <div :class="_.label">{{ item.title }}</div>
          </template>
        </div>
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { chunkEqual } from 'vtils'

  export default Vue.extend({
    computed: {
      groupData() {
        return chunkEqual(
          this.data,
          this.theme.lineCount * this.theme.rowCount,
          () => null,
        )
      },
      noPager() {
        return this.groupData.length === 1
      },
    },
  })
</script>

<style lang="scss" module="_">
  .container {
    border-radius: var(--border-radius);
    padding: var(--padding-top) var(--padding-right) var(--padding-bottom)
      var(--padding-left);
    padding-bottom: 8px;
    font-size: 0;

    .grids {
      width: 100%;
      padding-bottom: 8px;

      .grid {
        width: 100%;
        display: grid;
        grid-template-columns: repeat(var(--cols), 1fr);
        grid-gap: 10px;
        gap: 10px;

        .item {
          text-align: center;
          overflow: hidden;

          .icon {
            width: 45px;
            height: 45px;
          }

          .label {
            margin-top: 4px;
            font-size: 12px;
            color: var(--color);
            line-height: 17px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }

      :global {
        .van-swipe__indicators {
          bottom: 0px;
        }

        .van-swipe__indicator {
          width: 4px;
          height: 4px;
          background: rgba(0, 0, 0, 0.49);
          border-radius: 9px;
        }

        .van-swipe__indicator:not(:last-child) {
          margin-right: 3px;
        }

        .van-swipe__indicator--active {
          width: 8px;
          background: #ff111c;
        }
      }
    }

    &.noPager {
      padding-bottom: 10px;

      .grids {
        padding-bottom: 0;
      }
    }

    &.style2 {
      .grids {
        .grid {
          grid-gap: 0;
          gap: 0;

          .item {
            padding: var(--padding);

            .icon {
              display: block;
              width: 100%;
              height: auto;
            }

            .label {
              display: none;
            }
          }
        }
      }
    }
  }
</style>
